import React from 'react';

interface PaymentInputGroupProps {
    label: string;
    htmlFor?: string;
    error?: string | null;
    children: React.ReactNode;
    className?: string; // Optional class for the outer div
}

const PaymentInputGroup: React.FC<PaymentInputGroupProps> = ({ label, htmlFor, error, children, className = '' }) => {
    return (
        <div className={className}>
            <label htmlFor={htmlFor} className="block text-sm font-medium mb-2 text-[#667085]">
                {label}
            </label>
            {children}
            {error && (
                <p className="text-red-500 text-sm mt-1">{error}</p>
            )}
        </div>
    );
};

export default PaymentInputGroup;
